import { useSchedules } from "@/features/calendar/hooks/use-schedules";
import { useTranslation } from "@/features/utils/i18n";

interface ScheduleCellProps {
  scheduleId: string | null;
}

export function ScheduleCell({ scheduleId }: ScheduleCellProps) {
  const { t } = useTranslation("members");
  const { data: schedules = [] } = useSchedules();

  if (!scheduleId) {
    return (
      <span className="text-muted-foreground text-sm">
        {t("schedule.officeHours")}
      </span>
    );
  }

  const schedule = schedules.find((s) => s.id === scheduleId);
  return (
    <span className="text-sm">{schedule?.name || t("schedule.unknown")}</span>
  );
}
